import { render, staticRenderFns } from "./GPreview.vue?vue&type=template&id=dc0c8b06&scoped=true&"
import script from "./GPreview.vue?vue&type=script&lang=ts&"
export * from "./GPreview.vue?vue&type=script&lang=ts&"
import style0 from "./GPreview.vue?vue&type=style&index=0&id=dc0c8b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0c8b06",
  null
  
)

export default component.exports